// extracted by mini-css-extract-plugin
export default {"postError":"messageError_postError__7U9TZ","supportLink":"messageError_supportLink__272AW"};